// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d076f101","977":"80d23c31"}[chunkId] + ".chunk.js";
};